import { useQuery } from '@tanstack/react-query';

import { CONFIG } from '@constants/config';
import { QUERY_KEYS } from '@constants/query-keys';
import { areGeolocationParamsValid, arePlaceSearchParamsValid, isPlaceQueryValid } from '@helpers/PlacesHelpers';
import { getPlaceDetails, getPlaceDetailsByGeolocation, getPlaceSuggestions } from '@services/PlacesService';

export const usePlaceSuggestions = (query, options) => {
  return useQuery({
    queryKey: [
      QUERY_KEYS.PLACES_SUGGESTIONS,
      query
    ],
    queryFn: () => getPlaceSuggestions(query),
    staleTime: CONFIG.DURATIONS.DEFAULT_QUERY_STALE_TIME,
    enabled: isPlaceQueryValid(query),
    ...options
  });
};

export const usePlaceDetails = (params, options) => {
  const {
    id, street, number, city, province, lat, lng
  } = params || {};
  return useQuery({
    queryKey: [
      QUERY_KEYS.PLACE_DETAILS,
      id,
      street,
      number,
      city,
      province,
      lat,
      lng
    ],
    queryFn: () => getPlaceDetails(params),
    staleTime: CONFIG.DURATIONS.DEFAULT_QUERY_STALE_TIME,
    enabled: arePlaceSearchParamsValid(params),
    ...options
  });
};

// TODO: Currently not used, remove if not needed
export const usePlaceDetailsByGeolocation = (params, options) => {
  const { lat, lng } = params || {};
  return useQuery({
    queryKey: [
      QUERY_KEYS.PLACE_DETAILS_BY_GEOLOCATION,
      lat,
      lng
    ],
    queryFn: () => getPlaceDetailsByGeolocation(params),
    staleTime: CONFIG.DURATIONS.DEFAULT_QUERY_STALE_TIME,
    enabled: areGeolocationParamsValid(params),
    ...options
  });
};
